import { render, staticRenderFns } from "./InvitationManagement.vue?vue&type=template&id=24003324&scoped=true"
import script from "./InvitationManagement.vue?vue&type=script&lang=js"
export * from "./InvitationManagement.vue?vue&type=script&lang=js"
import style0 from "./InvitationManagement.vue?vue&type=style&index=0&id=24003324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24003324",
  null
  
)

export default component.exports